export const clearGarbageData = (state = {}) => {
    delete state.pageTitle;
    delete state.pageDescription;
    delete state.pageKeywords;
    delete state.mobile;
    delete state.footer;
};
export const clearGarbageAuthData = (state) => {
    delete state.auth;
};
export const clearGarbageDataForSendOrRequest = (state) => {
    clearGarbageData(state);
    delete state.browsers;
    delete state.languages;
    delete state.lang;
    delete state.jsMessages;
    delete state.messages;
    delete state.redirectTo;
    delete state.messageBodyMessages;
    delete state.authPromoAction;
    delete state.jsSettings;
    clearGarbageAuthData(state);
};
export const clearGarbageDataForReduxState = (state) => {
    clearGarbageData(state);
    delete state.browsers;
    delete state.languages;
    delete state.lang;
    delete state.jsMessages;
    delete state.messages;
    delete state.redirectTo;
    delete state.messageBodyMessages;
    delete state.authPromoAction;
    delete state.jsSettings;
    delete state.form;
    delete state.errors;
    delete state.responseCode;
    delete state.phone;
    delete state.breadCrumb;
    clearGarbageAuthData(state);
};
